$( '.fancy-title strong' ).each( function() {
	$( this ).html( `<span class="text-secondary inline-block bg-[url('../images/banner/shape.svg')] bg-no-repeat bg-bottom">` + $( this ).html() + '</span>' );
} );

$( '.fancy-title-2 strong' ).each( function() {
	$( this ).html( '<span class="shape-bg">' + $( this ).html() + '</span>' );
} );
